<template lang='pug'>
  .products-index-top-banner(v-if='bannerList.length > 0')
    .top-banner-container(v-for='banner in bannerList')
      template(v-if='banner.url')
        a.top-banner-link(:href='banner.url' :target='banner["new-tab"] ? "_blank" : null')
          img.top-banner(:src='banner.image' :alt='banner.alt')

      template(v-else)
        img.top-banner(:src='banner.image' :alt='banner.alt')

      template(v-if='bannerTermsText')
        a.terms-link(href='#billboard-terms' data-toggle='modal' v-text='$t("common.termsAndConditions")')
        terms-and-conditions(:description='bannerTermsText' :title='bannerTermsTitle')

    iframe(:id='bannerVideo' v-if='bannerVideo' frameborder='0' width='100%' height='100%' :src='`//www.youtube.com/embed/${bannerVideo}?rel=0&amp;enablejsapi=1&amp;modestbranding=1`' allowFullScreen='true')

    .holiday-lp(v-if="entityType === 'landing-pages'")
      template(v-if='entity.attributes["sub-banner"]')
        a.top-banner-link(v-if='entity.attributes["sub-banner"].link' :href='entity.attributes["sub-banner"].link')
          img.top-banner(:src='entity.attributes["sub-banner"].image' :alt='entity.attributes["sub-banner"]["alt-text"]')
        img.top-banner(v-else :src='entity.attributes["sub-banner"].image' :alt='entity.attributes["sub-banner"]["alt-text"]')

      ul.filter-tabs(v-if='entity.attributes["filter-tabs"]')
        template(v-for='tab in entity.attributes["filter-tabs"]')
          li.filter-tab(
            v-if='tab.image && tab.link && tab.text'
            :key='tab.image'
            :class='{ "active-filter-tab": isSelectedFitlerTab(tab.link) }'
          )
            a(:href='tab.link')
              img.filter-tab-banner(:src='tab.image' :alt='tab["alt-text"]')
              .filter-tab-title(v-text="tab.text")
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import TermsAndConditions from '../../billboards/terms-and-conditions.vue'
import { landingPageLayoutsWithEntity } from '@/modules/config/campaign'

export default {
  components: {
    TermsAndConditions
  },

  computed: {
    ...mapState({
      entity: state => state.product.entity,
      entityType: state => state.product.entityType,
      billboards: state => state.product.billboards,
      terms: state => state.product.terms
    }),
    ...mapGetters([
      'activeCategory'
    ]),
    isMobile: () => vueSupport.isMobile,

    bannerImage () {
      let image

      if (!this.isMobile && this.entityType === 'categories') {
        if (this.activeCategory.attributes && this.activeCategory.attributes['top-banners']) {
          image = this.activeCategory.attributes['top-banners']['top-banner2']
        }
      } else if (this.entityType === 'landing-pages' && landingPageLayoutsWithEntity.includes(this.entity.attributes.layout)) {
        image = this.entity.attributes['banner-image']
      }

      return image
    },

    bannerAlt () {
      let alt

      if (this.entityType === 'categories') {
        if (this.activeCategory.attributes && this.activeCategory.attributes['top-banners-details']) {
          alt = this.activeCategory.attributes['top-banners-details']['top-banner2-alt-text']
        }
      } else if (this.entityType === 'landing-pages' && landingPageLayoutsWithEntity.includes(this.entity.attributes.layout)) {
        alt = this.entity.attributes['banner-alt-text']
      }

      return alt
    },

    bannerLink () {
      if (this.entityType === 'landing-pages' && landingPageLayoutsWithEntity.includes(this.entity.attributes.layout)) {
        return this.entity.attributes['banner-link']
      } else {
        return undefined
      }
    },

    bannerVideo () {
      if (this.entityType === 'landing-pages' && landingPageLayoutsWithEntity.includes(this.entity.attributes.layout)) {
        return this.entity.attributes['banner-video-id']
      } else {
        return undefined
      }
    },

    bannerTermsText () {
      if (this.entityType === 'landing-pages' && landingPageLayoutsWithEntity.includes(this.entity.attributes.layout)) {
        return this.entity.attributes['tnc-text']
      } else if (this.entityType === 'product-groups' && this.terms && this.terms.attributes) {
        return this.terms.attributes.body
      } else {
        return undefined
      }
    },

    bannerTermsTitle () {
      if (this.entityType === 'product-groups' && this.terms && this.terms.attributes) {
        return this.terms.attributes.heading
      } else {
        return undefined
      }
    },

    bannerList () {
      if (this.entityType === 'product-groups') {
        return this.billboards.map(billboard => billboard.attributes)
      }
      return [
        {
          image: this.bannerImage,
          url: this.bannerLink,
          alt: this.bannerAlt
        }
      ]
    }
  },

  methods: {
    isSelectedFitlerTab (link) {
      return window.location.href === link
    }
  }
}
</script>

<style scoped lang='scss'>
  .top-banner-container {
    position: relative;
    margin-bottom: 25px;
  }

  .top-banner {
    vertical-align: bottom;
    width: 100%;
  }

  .terms-link {
    display: block;
    font-size: 11px;
    text-decoration: underline;
    text-align: center;
    line-height: 25px;
    transition: all 0.3s ease 0s;
    width: 120px;

    &:hover {
      background: $grey-dark;
      color: $white;
    }
  }

.filter-tabs {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 25px;
  margin-bottom: 25px;

  .filter-tab {
    width: 96px;
    border-radius: 10px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
    overflow: hidden;
    position: relative;
    cursor: pointer;

    .filter-tab-banner {
      width: 100%;
      vertical-align: bottom;
    }

    .filter-tab-title {
      @include font-sephora-sans;
      @include font-weight-bold;
      border-top: 1px solid $grey-light;
      text-transform: uppercase;
      color: $black;
      text-align: center;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    &.active-filter-tab {
        background-color: $black;

        .filter-tab-title {
          color: $white;
        }
      }
  }
}
</style>
